<template>

    <div class="rankingList">
        <div class="close" @click="close">
            <!-- <img src="@/assets/imgs/ThrowingGame/see/end.png" alt=""> -->
        </div>
        <div class="tit" v-if="isSeeIndex == 1">
            <h1 class="rankingTit">活动排行</h1>
            <div style="width: 100%;display: flex;justify-content: center;margin:0 auto 25px;color: #f8ca72;">
                <div style="width: 33%;text-align: center;font-size: 24px;">活动排行</div>
                <div style="width: 33%;text-align: center;font-size: 24px;">玩家账号</div>
                <div style="width: 33%;text-align: center;font-size: 24px;">完成次数</div>
            </div>
            <div>
                <div v-for="(item, index) in ActivityList" :key="index"
                    style="width: 90%;display: flex;justify-content: center;margin: 25px auto;color: #f8ca72;">
                    <div style="width: 33%;text-align: center;font-size: 19px;">NO.{{ item.rankPosition }}</div>
                    <div style="width: 33%;text-align: center;font-size: 19px;">{{ item.username }}</div>
                    <div style="width: 33%;text-align: center;font-size: 19px;">{{ item.completionCount }}</div>
                </div>
            </div>
            <div class="rankingUpdateTime">{{ updateTime }}</div>
        </div>
        <div class="tit" v-if="isSeeIndex == 2">

            <h1 class="ruleTit">活动规则</h1>
            <div class="day">
                <p>活动时间</p>
                <p>2026年9月23日—2026年10月18日23:59:59</p>
            </div>

            <div class="rule">
                <p> 1.玩家可以通过完成每日任务或商城购买获得活动所需骰子。</p>
                <p> 2.玩家点开始游戏，依据掷出骰子点数移动至相应位置并获取相应奖励。每次参与游戏需消耗一枚骰子。</p>
                <p> 3.玩家首次完成圈数后可获得啤酒国虎兵箱(低几率)(绑定)x1奖励，仅限一次。</p>
                <p>4.玩家依据完成圈数可激活相应巅峰奖励，巅峰奖励仅限领取一次，定制奖励请联系客服。</p>
                <p>5.活动奖励发放至网站商城个人仓库内</p>
                <!-- <p> 5.参与活动的玩家将录入活动排行榜。活动结束时排名前三的玩家将依据活动排名获得相应奖励，具体如下：<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;第一名：太阴星君基因定制<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;第二名：新版36星技能卡两张（随机）<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;第三名：新版36星技能卡一张（随机）</p>
                <p> 6.活动排名奖励均为绑定，将在活动结束后发放，我们将在活动结束后通过官方公告公布获奖名单。</p>
                <p> 7.如果完成圈数相同则随机抽选并且排名奖励依次顺延。</p> -->

            </div>
        </div>

        <div class="tit" v-if="isSeeIndex == 3">
            <h1 style="text-align: center;font-size: 30px;line-height: 80px;color: #f8ca72;margin-top: 20px;">恭喜获得奖励
            </h1>
            <div class="receiveAward">{{ SeeData.prizeName }}&nbsp;&nbsp;X{{ SeeData.prizeNum }}</div>

            <div class="shezhi">
                <img @click="recur(3)" src="@/assets/imgs/ThrowingGame/see/again-btn.png" alt="">
                <img @click="quit" src="@/assets/imgs/ThrowingGame/see/end-btn.png" alt="">
            </div>
        </div>
        <!-- 兑换弹窗确认 -->
        <div class="tit" v-if="isSeeIndex == 4">
            <div class="duihuanTishi">
                <!-- 标题 -->
                <div class="exchangeTitle">
                    兑换确认
                </div>

                <!-- 提示文字 -->
                <div class="exchangeText">
                    确定使用
                    <span class="price">
                        {{ SeeData.price || 0 }}
                    </span>
                    仙露兑换
                </div>

                <div class="exchangeText item-name">
                    {{ SeeData.itemName || '' }}？
                </div>

                <!-- 奖励图片 -->
                <div class="exchangeItem">
                    <img :src="SeeData.itemImg" :alt="SeeData.itemName || '兑换物品'" />
                </div>

                <!-- 按钮 -->
                <div class="exchangeButtons">
                    <button type="button" class="exchangeBtn cancelBtn" @click="quit">
                        取消
                    </button>

                    <button type="button" class="exchangeBtn confirmBtn" @click="recur(4)">
                        确定
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import { getRankListApi } from '@/api/Throwinggame/index'
export default {
    name: 'rankingList',
    props: {
        closeisSee: {
            type: Function,
            default: () => { },
            required: true
        },
        isSeeIndex: {
            type: Number,
            default: 1,
            required: true
        },
        SeeData: {
            type: Object,
            default: () => { },
            required: true
        }
    },
    data() {
        return {
            ActivityList: [],
            updateTime: ''
        }
    },
    created() {
        if (this.isSeeIndex == 1) {
            getRankListApi({
                activityName: '2025dice_activity',
                userId: Cookies.get('cwsl_userId'),      // userId
                platForm: 'web',
            }).then((res) => {
                if (res.data.state == 200) {
                    this.ActivityList = res.data.data.rankList;
                    this.updateTime = res.data.data.updateTime
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.$message.error(err.message)
            })
        }
    },
    methods: {
        close() {
            this.closeisSee();
        },

        // 再来一局
        recur(type) {
            this.$emit('recur',{type:type,item:this.SeeData});
        },

        // 退出游戏
        quit() {
            this.$emit('quits');
        }

    }
}
</script>

<style scoped lang="less">
.rankingList {
    width: 100%;
    height: 100%;
    // background-color: aqua;
    background-image: url('../../../assets/imgs/ThrowingGame/see/bg.png');
    background-size: 100% 100%;
    position: relative;

    .close {
        position: absolute;
        width: 50px;
        height: 50px;
        right: 125px;
        top: 53px;
        z-index: 100;
        cursor: pointer;

        >img {
            width: 100%;
            height: 100%;
        }
    }

    .tit {
        height: 80%;
        width: 57%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .rankingTit {
            text-align: center;
            font-size: 25px;
            line-height: 80px;
            color: #000000
        }

        .rankingUpdateTime {
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            padding: 10px 0;
            color: #f8ca72;
            font-size: 20px;
        }

        // font-size: 25px;
        // font-weight: bolder;
        // line-height: 100px;
        .ruleTit {
            text-align: center;
            font-size: 25px;
            line-height: 80px;
            color: #000000
        }

        .rule {
            // width: 80%;
            height: 60%;
            margin: 0 auto;
            overflow-y: scroll;
            // overflow:hidden;

            p {
                color: #000000;
                // height: 50px;
                line-height: 35px;
                font-weight: 700;
            }
        }


        .shezhi {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;

            img {
                width: 40%;
            }

        }

        .receiveAward {
            text-align: center;
            margin: 100px 0;
            line-height: 100px;
            font-size: 30px;
            font-weight: 800;
            color: #000000;
        }

        .day {

            >p {
                margin-bottom: 3%;
                text-align: center;
                font-size: 19px;
                font-weight: bold;
                color: #ffffff;
            }


        }

        // 兑换弹窗确认
        .duihuanTishi {
            position: relative;

            display: flex;
            flex-direction: column;
            align-items: center;

            box-sizing: border-box;
           
            // 标题
            .exchangeTitle {
                margin-bottom: 30px;

                color: #fff;
                font-size: 30px;
                font-weight: 800;
                line-height: 1.4;
                text-align: center;
            }

            // 提示文字
            .exchangeText {
                width: 100%;

                color: #fff;
                font-size: 20px;
                font-weight: 600;
                line-height: 36px;
                text-align: center;

                .price {
                    margin: 0 5px;

                    color: #ffc300;
                    font-size: 26px;
                    font-weight: 800;
                }

                &.item-name {
                    margin-top: 2px;

                    color: #ffc300;
                    font-size: 21px;
                }
            }

            // 奖励图片
            .exchangeItem {
                display: flex;
                align-items: center;
                justify-content: center;

                width: 130px;
                height: 130px;
                margin: 30px 0;

                background: rgba(255, 255, 255, 0.75);

                border: 3px solid #d9a34e;
                border-radius: 16px;

                box-shadow:
                    inset 0 0 15px rgba(180, 100, 30, 0.15),
                    0 5px 12px rgba(0, 0, 0, 0.15);

                img {
                    display: block;

                    width: 100px;
                    height: 100px;

                    object-fit: contain;

                    border-radius: 10px;
                }
            }

            // 按钮区域
            .exchangeButtons {
                display: flex;
                align-items: center;
                justify-content: center;

                width: 100%;
                gap: 30px;

                margin-top: auto;
            }

            // 两个按钮公共样式
            .exchangeBtn {
                width: 150px;
                height: 50px;

                border: 0;
                border-radius: 25px;

                color: #fff;
                font-size: 20px;
                font-weight: 700;

                cursor: pointer;

                transition:
                    transform 0.15s,
                    filter 0.15s;

                &:hover {
                    filter: brightness(1.08);
                    transform: translateY(-2px);
                }

                &:active {
                    transform: translateY(1px) scale(0.98);
                }
            }

            // 取消按钮
            .cancelBtn {
                background: linear-gradient(180deg,
                        #aaa,
                        #777);

                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
            }

            // 确定按钮
            .confirmBtn {
                background: linear-gradient(180deg,
                        #ed7047,
                        #c63b1f);

                box-shadow:
                    0 4px 10px rgba(180, 60, 20, 0.35),
                    inset 0 1px 0 rgba(255, 255, 255, 0.35);
            }

        }
    }
}
</style>